// extracted by mini-css-extract-plugin
export default {"ColSty":"StationEnergyInformation_ColSty__sLJe4"};